module.exports = __webpack_public_path__ + "img/精致面具--大图.2451dac9.png";